import React, { useMemo, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";

import {
  HvTableColumnConfig,
  useHvTable,
} from "@hitachivantara/uikit-react-lab";
import SimpleTable, {
  badgeColumn,
  numberColumn,
  switchColumn,
} from "components/common/SimpleTable";

import { populateMasterData, Severity, useSeverity } from "lib/api";

const SeverityTable: React.FC = () => {
  const { t } = useTranslation("incidentSeverity");
  const { data, mutate } = useSeverity();

  useEffect(() => {
    if (data && data.data && data.data.length === 0) {
      (async () => {
        await populateMasterData();
        await mutate();
      })();
    }
  }, [data, mutate]);

  const columns = useMemo(
    (): HvTableColumnConfig<Severity>[] => [
      numberColumn({
        Header: t("columns.order") as string,
        accessor: "inc_severity_order",
        style: { width: 100 },
      }),
      badgeColumn(
        {
          Header: t("columns.name") as string,
          accessor: "svrt_name",
          style: { width: "20%" },
        },
        "S",
        "inc_severity_order",
        "svrt_color",
        "svrt_name",
        true
      ),
      switchColumn(
        {
          Header: t("columns.default") as string,
          accessor: "svrt_is_default",
        },
        t("columns.default"),
        t("labels.no"),
        t("labels.yes")
      ),
    ],
    [t]
  );

  const instance = useHvTable<Severity>({
    columns,
    data: data?.data || [],
    getRowId: useCallback((v: Severity): string => `${v.pk_svrt_id}`, []),
  });

  return data ? (
    <SimpleTable
      instance={instance}
      totalCount={data?.totalCount}
      disableSelection
      disablePagination
    />
  ) : null;
};

export default SeverityTable;
